








































import { Button, Icon, Toast } from '@/components/ds';
import QrcodeVue from 'qrcode.vue';
import Vue from 'vue';

export default Vue.extend({
  components: {
    Button,
    Icon,
    QrcodeVue,
    Toast,
  },
  props: {
    pixCode: {
      type: String,
      required: true,
    },
    shouldRefreshQrcode: {
      type: Boolean,
      required: true,
    },
    timerClock: {
      type: String,
      required: true,
    },
    payOtherWay: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      wasCopied: false,
    };
  },
  methods: {
    refreshToken(): void {
      this.$emit('refreshToken');
    },
    async copyPixCode() {
      try {
        await navigator.clipboard.writeText(this.pixCode);
        this.wasCopied = true;
      } finally {
        setTimeout(() => {
          this.wasCopied = false;
        }, 5000);
      }
    },
  },
});
